import { Injectable } from '@angular/core';

import { PropsOf } from '@blaze-runtime/engine-domain';

import { hasProps } from '../../canvas-elements/element-model/element-props-guards';
import {
  OutputEmitGuard,
  PerformChecksConfig,
} from '../../canvas-elements/io-data/models/output-handler.models';

@Injectable({ providedIn: 'root' })
export class FormContainerOutputEmitGuard implements OutputEmitGuard {
  preEmit({ element, isDataContainerValueSetNotifier }: PerformChecksConfig): boolean {
    if (hasProps<PropsOf<'formContainer'>>(element) && element.props.content.action === 'insert') {
      // Inform about value update of the data container
      isDataContainerValueSetNotifier();
    }
    return true;
  }
}
